module.exports = __webpack_public_path__ + "static/img/two-flex-img4.d7b09e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lowCode/two-flex-img4.png
// module id = qel8
// module chunks = 0